import React, { Component } from 'react'
import sheetrock from 'sheetrock'

const GOOGLE_SHEET_URL =
  'https://docs.google.com/spreadsheets/d/1rBb9WgUsp8LhIQTRjepOcff60kZ--KxHQh3-gFtj7oU/edit#gid=29408373'
const SEPARATOR = '¶'

function extractResults (response) {
  return response.rows.reduce(function (results, row, index) {
    if (index !== 0) {
      results.push([
        row.cellsArray[0],
        row.cellsArray[2],
        row.cellsArray[4],
        row.cellsArray[6],
        row.cellsArray[8].split(SEPARATOR)
      ])
    }
    return results
  }, [])
}

var curlyQuotesRegex = /[“”]/g

function parseSearchTerm (searchTerm) {
  const characters = searchTerm.replace(curlyQuotesRegex, '"').split('')
  const length = characters.length
  const result = []
  let i = -1
  let accumulator = ''
  let isInsideQuote = false
  while (++i < length) {
    var character = characters[i]
    if (character !== '"' && isInsideQuote) {
      accumulator += character
      continue
    }
    if (character.charCodeAt(0) > 127) {
      if (accumulator !== '') {
        result.push(accumulator)
      }
      accumulator = ''
      result.push(character)
      continue
    }
    switch (character) {
      case '"':
        if (accumulator !== '') {
          result.push(accumulator)
        }
        accumulator = ''
        isInsideQuote = !isInsideQuote
        break
      default:
        accumulator += character
        break
    }
    accumulator = accumulator.trim()
  }
  if (accumulator !== '') {
    result.push(accumulator)
  }
  return result
}

function constructQuery (searchTerms) {
  const query = searchTerms.map(function (searchTerm) {
    return `(C contains "${searchTerm}" or E contains "${searchTerm}" or G contains "${searchTerm}" or I contains "${searchTerm}" or J contains "${searchTerm}")`
  })
  return `select B,C,D,E,F,G,H,I,J where ${query.join(' and ')} order by E asc`
}

function query (searchTerm, callback) {
  const searchTerms = parseSearchTerm(searchTerm)
  sheetrock({
    url: GOOGLE_SHEET_URL,
    query: constructQuery(searchTerms),
    reset: true,
    callback: (error, options, response) => {
      if (error) {
        return callback(null, [])
      }
      if (response.rows && response.rows.length > 1) {
        callback(null, extractResults(response))
      } else {
        callback(null, [])
      }
    }
  })
}

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      searchTerm: null,
      results: null
    }
    this.timeout = null
  }

  query () {
    if (this.state.searchTerm === '') {
      return
    }
    this.setState({
      isLoading: true
    })
    query(this.state.searchTerm, (error, results) => {
      if (!error) {
        this.setState({
          isLoading: false,
          results
        })
      }
    })
  }

  handleChange (event) {
    this.setState({
      searchTerm: event.target.value
    })
  }

  handleKeyPress (event) {
    if (event.key === 'Enter') {
      this.query.call(this)
    }
  }

  handleSearchButtonClick (event) {
    this.query.call(this)
  }

  render () {
    const { isLoading, results } = this.state
    return (
      <div className='App'>
        {isLoading && <div className='App__loading' />}
        <div className='App__sticky'>
          <input
            className='App__searchTextBox'
            type='text'
            placeholder='搜索…'
            value={this.state.value}
            onChange={this.handleChange.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}
          />
          <button
            className='App__searchButton'
            onClick={this.handleSearchButtonClick.bind(this)}
          >
            搜尋
          </button>
        </div>
        {results && (
          <div className='App__nonSticky'>
            <div className='App__resultsCount'>找到{results.length}条结果</div>
            {results.length > 0 && (
              <table className='App__table'>
                <thead className='App__tableHeaders'>
                  <tr>
                    <td className='App__tableCell App__tableCell--0'>书名</td>
                    <td className='App__tableCell App__tableCell--1'>作者</td>
                    <td className='App__tableCell App__tableCell--2'>出版社</td>
                    <td className='App__tableCell App__tableCell--3'>年代</td>
                    <td className='App__tableCell App__tableCell--4'>编号</td>
                  </tr>
                </thead>
                <tbody className='App__tableRows'>
                  {results.map(function (row, index) {
                    return (
                      <tr className='App__tableRow' key={index}>
                        {row.map(function (cell, cellIndex) {
                          return (
                            <td
                              className={`App__tableCell App__tableCell--${cellIndex}`}
                              key={cellIndex}
                            >
                              {Array.isArray(cell)
                                ? cell.map((callNumber, index) => (
                                  <span
                                    className='App__tableCellLine'
                                    key={index}
                                  >
                                    {callNumber}
                                  </span>
                                ))
                                : cell}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default App
